import { useCallback, useEffect, useMemo } from 'react'

import { useAuth0 } from '@auth0/auth0-react'
import useLoggedNavigate from 'hooks/useLoggedNavigate'
import { Button, Dialog, DialogActions } from '@mui/material'
import {
  BottomContent,
  ButtonContainer,
  DialogContentCenterbody,
  Title,
  UnauthorizedDialog,
} from './SomethingWentWrong.styled'
import InvertColorsOffIcon from '@mui/icons-material/InvertColorsOff'

function SomethingWentWrong() {
  const auth0 = useAuth0()
  const { isAuthenticated, isLoading, logout } = auth0
  const nav = useLoggedNavigate()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      nav('/')
    }
  })

  const login = useCallback(() => {
    console.log('Logging Out - User Account Error')
    logout({ logoutParams: { returnTo: window.location.origin } })
  }, [logout])

  return (
    <Dialog open={true}>
      {/* <Subtitles>Access Not Permitted</Subtitles> */}
      <Title>Uh Oh! Something went wrong!</Title>
      <UnauthorizedDialog>
        <DialogContentCenterbody>
          <InvertColorsOffIcon style={{ fontSize: '128px' }} />
        </DialogContentCenterbody>
        <BottomContent>
          Something went wrong while loading your account information. Please
          give us a moment to resolve the issue. If the problem persists, please{' '}
          <a
            //   className={Styles.standardAnchor}
            href={`mailto: ${
              process.env.REACT_APP_CUSTOMER_SERVICE_EMAIL
            }?Subject=${encodeURI('Account Permissions Request')}`}
          >
            contact customer service.{' '}
          </a>
          To try again, or log in to another account, press the "Login" button.
        </BottomContent>
        <ButtonContainer>
          <Button variant="contained" onClick={login} fullWidth>
            Login
          </Button>
        </ButtonContainer>
      </UnauthorizedDialog>
    </Dialog>
  )
}

export default SomethingWentWrong
